import { createAction } from '../helpers';

export const RESET_FORM = 'ManageJobs/job/RESET_FORM';

export const resetAddJobForm = createAction(RESET_FORM);
